import React, {useEffect, useState} from "react";
import {Snackbar, Typography} from "@material-ui/core";
import {useCookies} from "react-cookie";
import {removeSession} from "../../utils/sessionUtils";
import {useUserContext} from "../../context/UserContext";
import {useParams} from "react-router";
import {Alert} from "@material-ui/lab";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';

export default function Logout() {
    const {id} = useParams();
    const {user, dispatch} = useUserContext();
    const [cagCookie, setCookie, removeCookie] = useCookies(['cag_login_context_path']);
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const {instance, accounts } = useMsal();

    useEffect(() => {
        if (id === '1') {
            setOpenSnackBar(true);
        }
    },[id])

    useEffect(() => {        
         removeSession();
        // removeCookie('cag_login_context_path', {path: "/", domain: ".citizensfla.com"});
        // removeCookie('fmap_login_context_path', {path: "/", domain: ".citizensfla.com"});        
        dispatch({type: 'LOGIN_ERROR'});
        instance.logoutRedirect();
    }, []);

    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackBar(false);
    };
    return (
        <>
            {id === '1' && <Typography variant="h4" align="left" component="h4" gutterBottom
                        style={{paddingLeft: 24, fontWeight: 600, paddingTop: 20}}>
                Your session has ended.
            </Typography>}
            {id === '2' && <Typography variant="h4" align="left" component="h4" gutterBottom
                                       style={{paddingLeft: 24, fontWeight: 600, paddingTop: 20}}>
                An error has occurred. Please try again or reach out to us using the <a target="_blank" href="https://www.fmap.org/contact-us">contact us</a> feature.
            </Typography>}
            {id === '3' && <Typography variant="h4" align="left" component="h4" gutterBottom
                                       style={{paddingLeft: 24, fontWeight: 600, paddingTop: 20}}>
                Your session has expired. Please login to continue further.
            </Typography>}
            <Typography align="left"  style={{paddingLeft: 24}}>

            </Typography>

            <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert  variant="filled" onClose={handleSnackBarClose} severity="success">Agent withdrawn successfully!</Alert>
            </Snackbar>
        </>
    );
}
